import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { fetchFromHost, RequestType, ResponseType } from 'mini-host-bridge/lib/utils/fetchFromHost';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { isNativeFeatureEnabled } from 'mini-host-bridge/lib/utils/isNativeFeatureEnabled';
import { isSendFeedbackPolicyEnabledForBusinessUser } from 'mini-ocv-feedback/lib/utils/isSendFeedbackPolicyEnabledForBusinessUser';

interface HappySignals {
    sessionCount: number;
    daysSinceFirstLaunch: number;
    daysSinceLastFailure: number;
    hasUserIntendedToAddMultiAccounts: boolean;
    hasUserIntendedToAdd3PAccounts: boolean;
    hasUserGivenFeedback: boolean;
    isPrimaryAccount: boolean;
}

/**
 * Fetch real time signals from OPX host
 */
export const getMailSurfaceRealtimeSignalsFromHost = async (): Promise<string> => {
    if (
        !isMiniHostAppFeatureEnabled('hostCampaigns') ||
        !isNativeFeatureEnabled('rating-prompter')
    ) {
        return '';
    }

    const happySignals = await fetchFromHost<HappySignals>(
        RequestType.GET_HAPPY_SIGNALS,
        null,
        ResponseType.UPDATE_HAPPY_SIGNALS
    );

    if (!happySignals) {
        return '';
    }

    const {
        sessionCount,
        daysSinceFirstLaunch,
        daysSinceLastFailure,
        hasUserIntendedToAddMultiAccounts,
        hasUserIntendedToAdd3PAccounts,
        hasUserGivenFeedback,
        isPrimaryAccount,
    } = happySignals;

    const isEnabledByPolicy = await isUserEnabledByPolicy();

    return `SSCNT=${sessionCount}&DSFL=${daysSinceFirstLaunch}&DSLF=${daysSinceLastFailure}&HASMAINTENT=${Number(
        hasUserIntendedToAddMultiAccounts
    )}&HAS3PINTENT=${Number(hasUserIntendedToAdd3PAccounts)}&HASGIVENFB=${Number(
        hasUserGivenFeedback
    )}&ISPA=${Number(isPrimaryAccount)}&ISEBP=${Number(isEnabledByPolicy)}`;
};

// Exported for testing
export const isUserEnabledByPolicy = async (): Promise<boolean> => {
    /**
     * For consumer: check if user is not child (AADC policy).
     * For enterprise: check if user is not blocked by tenant policy to send feedback (OCPS policy).
     */
    try {
        const userConfiguration = getUserConfiguration();
        return isConsumer()
            ? !!userConfiguration && !userConfiguration.IsConsumerChild
            : await isSendFeedbackPolicyEnabledForBusinessUser();
    } catch (e) {
        return false;
    }
};
